import axios from "axios";

export default axios.create({
  baseURL:
    process.env.REACT_APP_ENV === "PROD"
      ? "https://bookingjini.info/website-builder-api-work"
      : "https://bookingjini.info/website-builder-api-work",
});
